export const DROPDOWN_OPTION_HEIGHT = 28;